import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './EmiSection.css';
import {
  cardVariants,
  hoverVariants,
  textVariants,
  listItemVariants
} from '../../utility/framerAnimations';

const EmiCardsSection = () => {
  return (
    <Container className="emi-cards-section">
      <Row className="justify-content-center">
        <Col lg={12} md={12}>
          <div className="cards-container">
            
            {/* Card 1: How EMI is Calculated */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/calculator.png" 
                  alt="Calculator Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                How EMI is Calculated
              </motion.h3>
              <motion.div 
                className="card-content"
                variants={textVariants}
              >
                <div className="formula-box">
                  <p className="formula-text">
                    E = P × r × (1 + r)<sup>n</sup> / ((1 + r)<sup>n</sup> - 1)
                  </p>
                  <div className="formula-explanation">
                    <p><strong>Where:</strong></p>
                    <ul>
                      <li>E = EMI amount</li>
                      <li>P = Principal loan amount</li>
                      <li>r = Monthly interest rate</li>
                      <li>n = Total number of months</li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            </motion.div>

            {/* Card 2: Why Choose Us? */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/building.png" 
                  alt="Building Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                Why Choose Us?
              </motion.h3>
              <motion.ul 
                className="card-list"
                variants={textVariants}
              >
                <motion.li variants={listItemVariants}>
                  Competitive interest rates
                </motion.li>
                <motion.li variants={listItemVariants}>
                  Quick loan approval
                </motion.li>
                <motion.li variants={listItemVariants}>
                  Flexible repayment options
                </motion.li>
              </motion.ul>
            </motion.div>

            {/* Card 3: Tips for Lower EMI */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/ai-innovation.png" 
                  alt="Lightbulb Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                Tips for Lower EMI
              </motion.h3>
              <motion.ul 
                className="card-list"
                variants={textVariants}
              >
                <motion.li variants={listItemVariants}>
                  Choose longer tenure
                </motion.li>
                <motion.li variants={listItemVariants}>
                  Make lump sum payments
                </motion.li>
                <motion.li variants={listItemVariants}>
                  Opt for fixed rate loans
                </motion.li>
              </motion.ul>
            </motion.div>

            {/* Card 4: Frequently Asked Questions */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/help-circle.png" 
                  alt="Question Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                Frequently Asked Questions
              </motion.h3>
              <motion.div 
                className="faq-content"
                variants={textVariants}
              >
                <div className="faq-item">
                  <h4 className="faq-question">What is EMI?</h4>
                  <p className="faq-answer">EMI stands for Equated Monthly Installment.</p>
                </div>
                <div className="faq-item">
                  <h4 className="faq-question">How is interest calculated?</h4>
                  <p className="faq-answer">Interest is calculated on the outstanding principal.</p>
                </div>
              </motion.div>
            </motion.div>

          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default EmiCardsSection; 